<template>
  <div class="box mt-4 step-navigation">
    <div class="d-flex justify-content-between">
      <button
        v-if="previous()"
        type="button"
        class="btn btn-primary position-relative button-previous-step"
        style="padding-left: 2.5rem"
        @click="updateStep(stepBackAction(route, routePrefix), previous()?.key)"
      >
        <i class="bi bi-arrow-left-circle-fill position-absolute lh-1 start-0 ms-2"></i>
        {{ previous()?.text }}
      </button>
      <Link
        v-else-if="before"
        :href="before.link"
        class="btn btn-primary text-white position-relative button-previous-step"
        style="padding-left: 2.5rem"
      >
        <i class="bi bi-arrow-left-circle-fill position-absolute lh-1 start-0 ms-2"></i>
        {{ before.text }}
      </Link>
      <div v-else></div>

      <button
        v-if="next()"
        :disabled="preventProgression"
        type="button"
        class="btn btn-primary position-relative button-next-step"
        style="padding-right: 2.5rem"
        @click="updateStep(stepForwardAction(route, routePrefix), next()?.key)"
      >
        <span>{{ next()?.text }}</span>
        <i class="bi bi-arrow-right-circle-fill position-absolute lh-1 end-0 me-2"></i>
      </button>
      <button
        v-else-if="after"
        :disabled="preventProgression"
        type="button"
        class="btn btn-accent button-next-step"
        @click="updateStep(stepAfterAction(route, routePrefix), after.step)"
      >
        <span>
          {{ after.text }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import { ref } from 'vue';
import useStepper from '@kanrisha/composables/useStepper';

export default {
  components: {
    Link,
  },
  props: {
    action: { type: String, default: () => 'edit' },
    updateAction: { type: String, default: () => 'update' },
    stepper: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    preventProgression: { type: Boolean, default: () => {} },
    resource: { type: Object, default: () => {} },
  },
  setup(props) {
    const resourceType = ref(props.resource.meta.resourceType);
    const { before, after, next, previous, updateStep } = useStepper(props);

    const stepForwardAction = (route, routePrefix) => {
      return props.stepper.options.action ?? stepDefaultAction(route, routePrefix);
    }

    const stepBackAction = (route, routePrefix) => {
      return props.stepper.options.action ?? stepDefaultAction(route, routePrefix);
    }

    const stepAfterAction = (route, routePrefix) => {
      return props.stepper.options.after.action ?? props.stepper.options.action ?? stepDefaultAction(route, routePrefix);
    }

    const stepDefaultAction = (route, routePrefix) => {
      return route(`${routePrefix}.${resourceType.value}.${props.updateAction}`, props.resource.data.id)
    }

    return {
      after,
      before,
      next,
      previous,
      resourceType,
      stepAfterAction,
      stepBackAction,
      stepForwardAction,
      updateStep,
    };
  },
};
</script>
